import React from 'react'
import PropTypes from 'prop-types'

export default class Checkbox extends React.Component {
  state = {
    isChecked: this.props.checked,
  }

  handleChange = () => {
    let checkState = !this.state.isChecked

    this.setState({ isChecked: checkState })
    this.props.onChange(checkState)
  }

  render() {
    return (
      <div className="status-marker">
        <input
          name="{this.props.title}"
          type="checkbox"
          onChange={this.handleChange} // eslint-disable-line react/jsx-no-bind
          checked={this.state.isChecked}
        />
      </div>
    )
  }
}
Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}
